import { cn } from '@/utils/cn';
import { Children, isValidElement, cloneElement, type ReactElement, type ReactNode } from 'react';
import { StatCard } from '@/components/ui/StatCard';

interface KpiGridProps {
  children: ReactNode;
  columns?: 2 | 3 | 4;
  className?: string;
}

const columnClass: Record<number, string> = {
  2: 'sm:grid-cols-2',
  3: 'sm:grid-cols-2 lg:grid-cols-3',
  4: 'sm:grid-cols-2 lg:grid-cols-4',
};

function isStatCardElement(child: ReactNode): child is ReactElement<{ iconToneIndex?: number }> {
  return isValidElement(child) && child.type === StatCard;
}

/** KPI row — assigns rotating icon colors to each StatCard (dashboard header style). */
export function KpiGrid({ children, columns = 4, className }: KpiGridProps) {
  let toneIndex = 0;
  const enhanced = Children.map(children, (child) => {
    if (!isStatCardElement(child)) return child;
    const next = cloneElement(child, { iconToneIndex: toneIndex });
    toneIndex += 1;
    return next;
  });

  return (
    <div className={cn('grid gap-4', columnClass[columns], className)}>{enhanced}</div>
  );
}
